import { get, find, isUndefined, map, values, includes, isString, padStart } from 'lodash'

export const transformResponsePayload = payload => {
  if (!payload) {
    return payload
  }

  return {
    ...payload,
    id: payload.uuid,
    attributes: payload.attributes.reduce(
      (acc, value) => ({
        ...acc,
        [value.name]: value.content.value,
      }),
      {},
    ),
  }
}

const getAttributeValue = ({ id, value }) => {
  const datesFields = ['employmentToMonthOverride', 'employmentFromMonthOverride']
  const monthPaddedFields = ['wasSubjectOfAbuseMonth', 'wasLicenseRevokedMonth']
  const dayPaddedFields = ['wasSubjectOfAbuseDay', 'wasLicenseRevokedDay']

  if (includes(datesFields, id)) {
    return get(value, 'id') || null
  }

  if (includes(monthPaddedFields, id)) {
    const monthId = get(value, 'id') || null

    return monthId && padStart(String(monthId), 2, '0')
  }

  if (includes(dayPaddedFields, id)) {
    return value ? padStart(String(value), 2, '0') : null
  }

  return !isUndefined(value) ? value : null
}

export const transformRequestPayload = ({ form = {}, formData = {} }) => ({
  status: form.status,
  type: form.type,
  uuid: form.uuid,
  attributes: map(values(formData), ({ value, id, isTrimPayloadValue }) => {
    const fieldValue = getAttributeValue({ id, value })
    const trimmedValue = isTrimPayloadValue && isString(fieldValue) ? fieldValue.trim() : fieldValue

    return {
      id: get(find(form.attributes, { name: id }), 'id'),
      name: id,
      content: {
        value: trimmedValue,
      },
    }
  }),
})
